import styled from "styled-components";

export const CreateMessageSuppressionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabsContainer = styled.div`
  padding-block: 24px;
`; 